// GA4 / Firebase Analytics event helpers. No-ops gracefully when analytics isn't initialized
// (missing measurementId — DRB-17) or in local dev. Wired to logEvent per DRB-2.

import { logEvent } from 'firebase/analytics';
import { analytics } from '@/services/firebase';

type EventName =
  | 'page_view'
  | 'view_item'
  | 'add_to_cart'
  | 'remove_from_cart'
  | 'begin_checkout'
  | 'purchase'
  | 'subscription_start'
  | 'subscription_cancel'
  | 'sign_up'
  | 'login'
  | 'search';

// Firebase logEvent has strict per-event-name overloads that conflict with our union type.
// Cast to a generic form — the runtime call is correct.
type FlexLogEvent = (a: NonNullable<typeof analytics>, e: string, p?: Record<string, unknown>) => void;
const _logEvent = logEvent as unknown as FlexLogEvent;

export function track(event: EventName, params: Record<string, unknown> = {}): void {
  if (import.meta.env.DEV) {
    // eslint-disable-next-line no-console
    console.debug(`[analytics] ${event}`, params);
    return;
  }
  if (analytics) _logEvent(analytics, event, params);
}
